import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectLocale } from 'app/redux/language/selectors';

IntlCrawlableLink.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  target: PropTypes.string,
  title: PropTypes.string,
};

export default function IntlCrawlableLink({
  children,
  className = null,
  style = null,
  url,
  onClick = undefined,
  target = undefined,
  title = undefined,
}: {
  url: string;
  children: React.ReactNode;
  className?: string | null;
  style?: React.CSSProperties | null;
  onClick?: () => void;
  target?: string;
  title?: string;
}) {
  const locale = useSelector(selectLocale);
  return (
    <Link
      className={className}
      style={style}
      to={`/${locale}${url}`}
      onClick={onClick}
      target={target}
      title={title}
    >
      {children}
    </Link>
  );
}
